export const PDF_MIME_TYPE = 'application/pdf'

export const ACCEPTED_FILE_TYPES = '.jpeg, .jpg, .png, .pdf'
export const ACCEPT_ONLY_IMAGES = '.jpeg, .jpg, .png'

export const SORRY = 'Sorry!'
export const ERROR_HEADING = 'We’re Experiencing Issues with our System'
export const ERROR_MESSAGE = 'We are unable to process your request at this time. Please try again later.'

export const DELETE_DOCUMENT_MODAL_TITLE = 'Delete Document?'
export const DELETE_DOCUMENT_MODAL_CONTENT =
    'Are you sure you want to delete this document? You may need to replace it.'
export const NO_GO_BACK = 'No, Go Back'
export const YES_DELETE = 'Yes, Delete'

export const IMAGE_FILE_COMPRESSION = true
export const IMAGE_FILE_QUALITY = 0.4
export const MAX_MB = 5
export const MAX_UPLOAD_SIZE = 10
export const MB_TO_BYTES = 1024 * 1024
export const DOC_MAX_SIZE = MAX_MB * MB_TO_BYTES
export const MB = 'MB'

export const TITLE = 'Please Upload Dealer Requested Documents'
export const REQUESTED_BY = 'Requested by:'
export const NO_DOCUMENT_MESSAGE = 'There are no documents requested at this time.'
export const SUB_HEADING_1 =
    'By uploading, you represent all information is current and accurate and you have the right to provide it.'
export const SUB_HEADING_2 = "This information is subject to your dealer's privacy policy."
export const MAX_FILE_SIZE = `Max file size: ${MAX_MB} ${MB} | `
export const MAX_TOTAL_UPLOAD_SIZE = `Max total upload size: ${MAX_UPLOAD_SIZE} ${MB} | `
export const PREPARING_DOCUMENT = 'Preparing Document'

export const APPLICANT = 'Applicant'
export const CO_APPLICANT = 'Co-Applicant'
export const COBUYER = 'cobuyer'

export const CANCEL = 'Cancel'
export const DELETE = 'Delete'
export const EDIT = 'Edit'
export const UPLOAD = 'Upload'
export const FRONT = 'Front'
export const BACK = 'Back'
export const RETAKE = 'Replace'
export const DONE = 'Done'

export const STATUS_LIST = {
    PENDING: 'PENDING',
    COMPLETED: 'COMPLETED',
    INPROGRESS: 'INPROGRESS',
    ERROR: 'ERROR',
    FILESIZEERROR: 'FILESIZEERROR',
    UPLOADED: 'UPLOADED'
}

export const ERROR_TOASTER_TITLE = 'Upload Error'
export const FILE_SIZE_TOASTER_CONTENT = `File is too large. Maximum file size is ${MAX_MB} ${MB}. Please reduce your file size and try again.`
export const UNSUPPORTED_FILE_TYPE_TOASTER_CONTENT =
    'Unsupported file type. You can only upload .jpeg, .jpg, .png or .pdf.'

export const ERROR_FILE_SIZE_CARD_TITLE = 'File Exceeded 5MB'
export const ERROR_FILE_SIZE_CARD_CONTENT = 'Reduce file size & try again.'

export const ERROR_CARD_UNSUPPORTED_FILE_TITLE = 'Unsupported File Type'
export const ERROR_CARD_UNSUPPORTED_FILE_CONTENT = 'Upload .jpeg, .jpg, .png or .pdf only.'

export const ONLY_IMAGE_SUPPORTED_TOASTER_CONTENT = 'Unsupported file type. You can only upload .jpeg, .jpg or .png.'

export const DOCUMENTS = 'documents'

export const FILE_SIZE_STATUS_CODE = 413
export const SUCCESS_STATUS_CODE = 200
export const HARMFUL_STATUS_CODE = 422
export const FILE_SIZE_ERROR = 'upload doc file too large'
export const UNSUPPORTED_FILE_TYPE_ERROR = 'unsupported file type'
export const HARMFUL_JAVASCRIPT_ERROR_CODE = `JavaScript injected file`
export const HARMFUL_VIRUS_ERROR_CODE = `Virus infected file`
export const HARMFUL_JAVASCRIPT_ERROR = `potentially harmful file javascript`
export const HARMFUL_VIRUS_ERROR = `potentially harmful file virus scan`
export const HARMFUL_TOASTER_TITLE = `Potentially Harmful File`
export const HARMFUL_TOASTER_CONTENT = `The file you are attempting to upload may be harmful. Please upload a different file.`

export const HARMFUL_TOASTER_CARD_TITLE = `Harmful File`
export const HARMFUL_TOASTER__CARD_CONTENT = `Please upload a different file.`
